import { SchemaType } from '../type';
export const schema = {
    id: 'ai-page',
    name: 'AI页面',
    type: SchemaType.Indivisible,
    identityField: 'name',
    fieldUncheckable: true,
};
